import PageLayout from './PageLayout';

export default PageLayout;



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Catalog/Components/PageLayout/index.ts